import { useState } from "react";
import { Building2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function CustomerLogo({ clientId, hasLogo, className = "", size = 44, iconSize = 22, bust }) {
  const [err, setErr] = useState(false);
  const style = { width: size, height: size };

  if (hasLogo && !err) {
    return (
      <div
        className={`overflow-hidden rounded border border-border bg-white grid place-items-center ${className}`}
        style={style}
      >
        <img
          src={`${API}/customers/${clientId}/logo${bust ? `?t=${bust}` : ""}`}
          alt=""
          className="h-full w-full object-contain p-1"
          onError={() => setErr(true)}
          data-testid={`customer-logo-${clientId}`}
        />
      </div>
    );
  }
  return (
    <div className={`grid place-items-center rounded bg-secondary ${className}`} style={style}>
      <Building2 size={iconSize} />
    </div>
  );
}
